import { ArticleLayout } from "types/api";
import { ArticleRenderNotSupported } from "./error";

export default function checkArticleRenderSupport({
  article: { layout },
}: {
  article: { layout: ArticleLayout };
}) {
  if (layout === "feature") {
    // In prod, return error; otherwise log a warning
    if (process.env.ENABLE_FEATURE_ARTICLE_RENDER !== "1") {
      throw new ArticleRenderNotSupported();
    } else {
      console.warn("Attempting to render an article that may not be supported");
    }
  }
}
